/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { SimpleAction } from './simple-action';
import { StandardAction } from './standard-action';
import { CheckState } from '../../enum/check-state.enum';

export class DropdownGroupAction extends SimpleAction<SimpleAction<any>[]> {
  override get check(): boolean {
    if (this.items) {
      return (
        this.items.filter((item) => item.check).length === this.items.length
      );
    }
    return false;
  }

  override set check(value: boolean) {
    if (this.items) {
      this.items.forEach((d) => (d.check = value));
    }
  }

  override get checkState(): CheckState {
    if (this.items) {
      const count = this.items.filter((item) => item.check).length;
      switch (count) {
        case 0:
          return CheckState.uncheck;
        case this.items.length:
          return CheckState.check;
        default:
          return CheckState.partial;
      }
    }
    return CheckState.uncheck;
  }
  public items: StandardAction[] = [];

  constructor(
    name: string,
    icon: string,
    values: SimpleAction<any>[],
    text: string,
  ) {
    super(name, icon, null, text);
    this.items = values;
    this.category = 'group';
  }

  public addItem(item: SimpleAction<any>) {
    this.items.push(item);
  }

  public override toString(): string {
    return this.text;
  }
}
